@let doc = this.doc();

<div
    class="doc-mini"
    data-testid="doc-mini"
    role="button"
    tabindex="0"
    (click)="openDoc($event)"
    (keydown.enter)="openDoc($event)"
    (keydown.space)="$event.preventDefault(); openDoc($event)"
    (mouseenter)="showTablePreview()"
    (mouseleave)="scheduleClosePreview()">
    <div class="state" data-testid="doc-mini-state" [style.background-color]="doc.stateColor"></div>
    <div class="time" data-testid="doc-mini-time">
        {{ doc.time }}
    </div>
    <div class="desc" data-testid="doc-mini-desc" [title]="doc.descTableRows?.length ? null : doc.desc">
        {{ doc.desc }}
        @if (doc.descMoreRowsCount) {
            <span class="desc-more" data-testid="doc-mini-desc-more">
                {{ "MODULE_INSTANCE_CALENDAR.N_MORE" | translate: { n: doc.descMoreRowsCount } }}
            </span>
        }
    </div>
</div>

<ng-template #tablePreviewTpl>
    <div class="table-preview" data-testid="doc-mini-table-preview">
        <table>
            @if (doc.descTableColumns?.length) {
                <tr>
                    @for (column of doc.descTableColumns; track $index) {
                        <th>{{ column }}</th>
                    }
                </tr>
            }
            @for (row of doc.descTableRows; track $index) {
                <tr>
                    @if (doc.descTableColumns?.length) {
                        @for (column of doc.descTableColumns; track $index; let i = $index) {
                            <td>{{ row[i] }}</td>
                        }
                    } @else {
                        @for (value of row; track $index) {
                            <td>{{ value }}</td>
                        }
                    }
                </tr>
            }
        </table>
    </div>
</ng-template>
